<template>
  <star-rating
    :rating="value"
    :star-size="18"
    :show-rating="false"
    :active-color="value < 3 ? '#f85959' : '#4db1fa'"
    border-color="#e6e6e6"
    :border-width="1"
    :read-only="readonly"
    @rating-selected="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: ['value', 'readonly'],
}
</script>
